<!-- 编辑商品 -->

<template>
  <a-modal v-model:visible="visible" :title="title" :maskClosable="false" width="500px">
    <template #footer>
      <a-button key="back" @click="handleCancel">关闭</a-button>
      <a-button key="back" @click="deleteGoods" :loading="loading" type="danger">确定删除</a-button>
    </template>

    <div v-if="!item">
      <a-radio-group v-model:value="goodsDeleteType" button-style="solid">
        <a-radio-button value="1">根据页码操作</a-radio-button>
        <a-radio-button value="2">根据勾选项操作</a-radio-button>
      </a-radio-group>
    </div>

    <div v-if="goodsDeleteType == 1" class="set_header" style="margin-top: 10px">
      <div class="set_box">
        请输入需要执行的页码：第1页到第 <a-input-number size="small" :min="1" v-model:value="tableInfo.page" />页
      </div>
    </div>
  </a-modal>
</template>

<script>
import {getProductList, deleteProduct} from "../../good_manage_api"
export default {
  components: {},
  data() {
    return {
      loading: false,
      title: "",
      goodsDeleteType: "1",
      visible: false,
      queryParams: {},
      tableInfo: {pageSize: 50, page: 1, list: []},
      selectRows: [],
    }
  },
  methods: {
    //入口
    open(selectRows, queryParams, tableInfo) {
      this.selectRows = selectRows
      this.queryParams = queryParams
      this.tableInfo.pageSize = tableInfo.pageSize
      this.visible = true
    },

    //关闭方法`
    handleCancel() {
      this.visible = false
    },
    //删除商品
    async deleteGoods() {
      this.loading = true
      const itemIds = []
      if (this.goodsDeleteType == 2) {
        this.selectRows.forEach((res) => {
          itemIds.push(res.ItemId)
        })
      } else {
        await this.getData()
        this.tableInfo.list.forEach((res) => {
          itemIds.push(res.ItemId)
        })
      }
      const {success, msg} = await deleteProduct({itemIds: itemIds.join(",")})
      if (success) {
        this.$message.success(msg || "删除成功")
      } else {
        this.$message.error(msg || "删除失败")
      }
      this.loading = false
      this.handleCancel()
      this.$emit("delete")
    },
    //获取商品列表
    async getData() {
      const query = {
        page: this.tableInfo.page,
        size: this.tableInfo.pageSize,
        publicStatus: 1,
        ...this.queryParams,
      }

      const {result, success, msg} = await getProductList(query)

      if (!success) {
        this.$message.error(msg || "授权码无效或未购买服务", 2)
      } else if (result) {
        this.tableInfo.list = result.Data || result.Datas
        this.tableInfo.total = result.TotalNum
      }
    },
  },
  mounted() {},
}
</script>

<style scoped lang="less">
.goods_header {
  display: flex;
  .header_item {
    margin-right: 10px;
  }
}
.good_info2 {
  text-align: center;
}
.good_info {
  display: flex;
  flex-direction: row;
  align-items: flex-start;

  .good_img {
    width: 75px;
    height: 75px;
  }
  .good_text {
    text-align: left;
    cursor: pointer;
    .good_goto {
      color: #007fff;
    }
  }
}
</style>
